var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalCount)?_c('a-pagination',{staticClass:"queryView-pagination",attrs:{"total":_vm.totalCount,"current":_vm.pageNo,"pageSize":_vm.pageSize,"showTotal":_vm.showTotalFn ? _vm.showTotalFn : null,"size":_vm.size,"showSizeChanger":"","showQuickJumper":""},on:{"change":_vm.onChange,"showSizeChange":_vm.onChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }